module.exports = __webpack_public_path__ + "static/media/happy-people.7fa42807.png";